import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import GlobalSettings from '@/components/settings/GlobalSettings';
import { useScreenSize } from '@/hooks';
import styles from './Settings.module.css';

/**
 * Settings Page
 * Full-page route for Global Settings
 * Route: /settings or /global-settings
 */
const Settings = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isMobile } = useScreenSize();
  const sectionParam = searchParams.get('section');

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.container}>
      {/* Header with back button on mobile */}
      {isMobile && (
        <div className={styles.mobileHeader}>
          <button
            className={styles.backButton}
            onClick={handleBack}
            aria-label="Go back"
          >
            <ArrowLeft size={20} />
          </button>
          <h1 className={styles.title}>Global Settings</h1>
        </div>
      )}

      {/* Desktop header */}
      {!isMobile && (
        <div className={styles.desktopHeader}>
          <h1 className={styles.title}>Global Settings</h1>
        </div>
      )}

      {/* Settings Content */}
      <div className={styles.content}>
        <GlobalSettings />
      </div>
    </div>
  );
};

export default Settings;
